import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalVariable } from '../Variable/global-variable';
import { Router} from '@angular/router';
import { HTTPStatus } from 'src/app/Global-Services/app-token-handler';
import { CommonService } from 'src/app/Global-Services/common.service';
import * as XLSX from 'xlsx';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelUploadService {
  progress$: any;
  progressObserver: any;
  private User: any = null;
  constructor(private gVariable: GlobalVariable, private router: Router,
     public _httpLoader: HTTPStatus, public gService: CommonService) {
   }
   getUserDetails() {
    this.User = JSON.parse(sessionStorage.getItem('userDetails'));
    if (this.User == null) {
        this.router.navigate(['/error/logout']);
    } else {
        return this.User;
    }
}

public exportAsExcelFile(json: any, excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    console.log('worksheet', worksheet);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, excelFileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION, { bookType: 'xlsx', type: 'buffer' });
    }

}
